import { guardedNavigate } from '../lib/apiGuard/guardedNavigation';

type NavigateFn = (to: string) => void;
let navigateFn: NavigateFn | null = null;
export const registerNavigate = (fn: NavigateFn): void => { navigateFn = fn; };
export const navigateTo = (to: string): void => {
  if (navigateFn) {
    navigateFn(to);
  } else {
    guardedNavigate(to);
  }
};
